import { brand, tg } from '../../theme/tokens';

interface StepIndicatorProps {
  step: number;       // 1-based: 1, 2, 3, 4
  total?: number;     // default 4
}

/**
 * Thin horizontal progress strip — N equal segments above the page H1.
 * Segments at index < step are brand-colored (completed/current), the rest
 * are the section-separator gray (pending).
 *
 * No textual "Step X of Y" label by design — the segment fill ratio
 * communicates progress, and avoiding extra text gives the wizard a
 * lighter, less form-like feel. The actual page H1 under this strip
 * names the current step semantically (e.g. "Choose a scene").
 */
export function StepIndicator({ step, total = 4 }: StepIndicatorProps) {
  return (
    <div style={{ display: 'flex', gap: 6, padding: '14px 20px 0' }}>
      {Array.from({ length: total }).map((_, i) => (
        <div
          key={i}
          style={{
            flex: 1,
            height: 4,
            borderRadius: 999,
            background: i < step ? brand.solid : tg.divider,
            transition: 'background 250ms',
          }}
        />
      ))}
    </div>
  );
}
